module.exports = __webpack_public_path__ + "static/media/video-breathing-ja.9e4c2c22.vtt";